var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ticket-form',{attrs:{"action":_vm.create}})
}
var staticRenderFns = []

export { render, staticRenderFns }